// removed by extract-text-webpack-plugin
module.exports = {"content":"CoursesView__content___1CIyO"};